import { c as _c } from "react/compiler-runtime";
import { twMerge } from "tailwind-merge";
import PartyIcon from "@components/party/icon";
import type { VotingResult } from "@lib/api/vote/types";
import type { Party } from "@partiguiden/party-data/types";
interface ResultColumnProps {
  votes: Party[];
  title: string;
  className: string;
}
function ResultColumn(t0) {
  const $ = _c(12);
  const {
    votes,
    title,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("flex-1 px-2 py-4 text-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <p>{title}</p>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== votes) {
    t3 = votes.map(_temp);
    $[4] = votes;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="mt-4 flex flex-wrap justify-center gap-2 px-2">{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(party) {
  return <PartyIcon party={party} key={party} className="h-8 w-8 md:h-10 md:w-10" sizes="(min-width: 768px) 32px, 40px" />;
}
interface Props {
  votes: VotingResult;
}
export default function VoteResult(t0) {
  const $ = _c(14);
  const {
    votes
  } = t0;
  if (!votes.no.length || !votes.yes.length) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p>Ingen voteringsdata hittades</p>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = votes.winner !== "yes" && "bg-slate-200 dark:bg-slate-600 text-black dark:text-white";
  let t2;
  if ($[1] !== t1) {
    t2 = twMerge("bg-emerald-600 dark:bg-emerald-700 text-white", t1);
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2 || $[4] !== votes.yes) {
    t3 = <ResultColumn className={t2} title="JA" votes={votes.yes} />;
    $[3] = t2;
    $[4] = votes.yes;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = votes.winner !== "no" && "bg-slate-200 dark:bg-slate-600 text-black dark:text-white";
  let t5;
  if ($[6] !== t4) {
    t5 = twMerge("bg-red-500 dark:bg-red-600 text-white", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5 || $[9] !== votes.no) {
    t6 = <ResultColumn className={t5} title="NEJ" votes={votes.no} />;
    $[8] = t5;
    $[9] = votes.no;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <div className="flex flex-col sm:flex-row">{t3}{t6}</div>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}